/* Header Tenfit JS
 * - Drawer mobile (con focus-trap y aria)
 * - Mega desktop (hover + fallback mouse)
 * - Toggles de subcategorías
 * - Tabs de Sale
 * - “New” subcategorías -> productos recomendados dinámicos
 * Nota: mantiene clases/estructura existentes.
 */

document.addEventListener('DOMContentLoaded', () => {
    const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);


    // Utilidades mostrar/ocultar que respetan [hidden]
    const showEl = (el, display = 'block') => { if (!el) return; el.style.display = display; el.removeAttribute('hidden'); };
    const hideEl = (el) => { if (!el) return; el.style.display = 'none'; el.setAttribute('hidden', ''); };

    // ==================== Header offset CSS var ====================
    // const setHeaderOffset = () => {
    //   const header = document.querySelector('.tenfit-header') || document.querySelector('header');
    //   const h = header ? header.offsetHeight : 56; // valor seguro por defecto
    //   document.documentElement.style.setProperty('--header-h', h + 'px');
    // };
    // setHeaderOffset();
    // window.addEventListener('resize', setHeaderOffset, { passive: true });
    // window.addEventListener('load', setHeaderOffset);
    // window.addEventListener('scroll', setHeaderOffset, { passive: true });

    // ==================== Drawer Mobile ====================
    (() => {
        const MQ = window.matchMedia('(max-width: 1280px)');

        const bindContainer = (container) => {
            if (container.dataset.bound === '1') return;
            container.dataset.bound = '1';

            const uid = container.getAttribute('data-mobile-container');
            const toggleBtn = container.querySelector('#MenuToggleButton-' + uid);
            const panel = container.querySelector('#MobileMenu-' + uid);
            const backdrop = container.querySelector('#MobileBackdrop-' + uid);
            const iconMenu = toggleBtn?.querySelector('.icon-menu');
            const iconClose = toggleBtn?.querySelector('.icon-close');
            let focusables = [];
            let prevFocus = null;

            if (!toggleBtn || !panel) return;

            // Asegura foco programable
            if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');

            // Handlers nominales para poder desuscribir
            const onPanelLinkClick = (e) => {
                const a = e.target.closest('a[href]');
                if (!a) return;
                const href = a.getAttribute('href') || '';
                if (href.startsWith('#') || href === '' || a.hasAttribute('data-no-close')) return;
                close();
            };

            const onDocKeydown = (e) => {
                if (!panel.classList.contains('open')) return;
                if (e.key === 'Escape') { e.preventDefault(); return void close(); }
                if (e.key === 'Tab' && focusables.length) {
                    const first = focusables[0], last = focusables[focusables.length - 1];
                    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
                    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
                }
            };

            const open = () => {
                prevFocus = document.activeElement;
                panel.classList.add('open');
                backdrop?.classList.add('open');

                panel.setAttribute('aria-hidden', 'false');
                toggleBtn.setAttribute('aria-expanded', 'true');

                // document.body.classList.add('mobile-menu-open');
                // document.documentElement.classList.add('mobile-menu-open');

                // === iOS SAFE SCROLL LOCK ===
                const scrollY = window.scrollY;
                document.body.dataset.scrollY = scrollY;
                document.body.style.position = 'fixed';
                document.body.style.top = `-${scrollY}px`;
                document.body.style.left = '0';
                document.body.style.right = '0';
                document.body.style.width = '100%';


                if (iconMenu) iconMenu.style.display = 'none';
                if (iconClose) iconClose.style.display = 'block';

                focusables = Array.from(
                    panel.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                ).filter(el =>
                    !el.hasAttribute('disabled') &&
                    el.getClientRects().length > 0
                );

                //.filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);

                panel.focus?.({ preventScroll: true });

                // Notifica para bind del push panel
                document.dispatchEvent(new CustomEvent('tenfit:mobileMenuOpened', { detail: { panel } }));

                // Suscribe handlers que solo deben vivir mientras está abierto
                panel.addEventListener('click', onPanelLinkClick);
                document.addEventListener('keydown', onDocKeydown);
            };

            const resetPush = () => {
                panel.querySelectorAll('[data-mobile-list]').forEach(list => {
                    list.classList.remove('is-pushed');
                    list.querySelectorAll('.accordion-item.is-open').forEach(it => {
                        it.classList.remove('is-open');
                        if (!isIOS) {
                            it.open = false;
                            it.removeAttribute('open');
                        }
                        it.querySelector('summary')?.setAttribute('aria-expanded', 'false');
                        it.querySelector('.accordion-icon')?.classList.remove('rotate');
                    });
                });
            };

            const close = () => {
                panel.classList.remove('open');
                backdrop?.classList.remove('open');

                panel.setAttribute('aria-hidden', 'true');
                toggleBtn.setAttribute('aria-expanded', 'false');

                // document.body.classList.remove('mobile-menu-open');
                // document.documentElement.classList.remove('mobile-menu-open');
                // === RESTORE SCROLL (iOS SAFE) ===
                const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.left = '';
                document.body.style.right = '';
                document.body.style.width = '';
                document.body.removeAttribute('data-scroll-y');
                window.scrollTo(0, scrollY);

                if (iconMenu) iconMenu.style.display = 'block';
                if (iconClose) iconClose.style.display = 'none';

                // --- NUEVO: Resetear todos los iconos y estados internos ---
                // Resetear TODOS los items y flechas al cerrar el menú completo
                panel.querySelectorAll('.accordion-item').forEach(it => {
                  it.classList.remove('is-open');
                  it.open = false;
                  it.removeAttribute('open');
                  it.querySelector('.accordion-icon')?.classList.remove('rotate');
                });
                
                panel.querySelectorAll('.sub-accordion-item').forEach(sub => {
                  sub.open = false;
                  sub.removeAttribute('open');
                  sub.querySelector('.accordion-icon')?.classList.remove('rotate');
                });

                resetPush();                                                // << resetea push correctamente

                // Desuscribe handlers de ciclo abierto
                panel.removeEventListener('click', onPanelLinkClick);
                document.removeEventListener('keydown', onDocKeydown);

                prevFocus?.focus?.({ preventScroll: true });
            };

            toggleBtn.addEventListener('click', () => {
                if (!MQ.matches) return;
                panel.classList.contains('open') ? close() : open();
            });

            backdrop?.addEventListener('click', close);

            // expone close para unbind
            container._drawer = { close, _onDocKeydown: onDocKeydown, _onPanelLinkClick: onPanelLinkClick, panel, toggleBtn, backdrop };
        };

        const unbindContainer = (container) => {
            // Cierra y limpia si estaba abierto
            container._drawer?.close?.();
            const d = container._drawer;
            if (d) {
                d.panel?.removeEventListener('click', d._onPanelLinkClick);
                document.removeEventListener('keydown', d._onDocKeydown);
            }
            container._drawer = undefined;

            container.dataset.bound = '';
            document.body.classList.remove('mobile-menu-open');
            document.documentElement.classList.remove('mobile-menu-open');
        };

        const init = () => {
            document.querySelectorAll('[data-mobile-container]').forEach(c => {
                MQ.matches ? bindContainer(c) : unbindContainer(c);
            });
        };

        init();
        MQ.addEventListener?.('change', init);
    })();

    (() => {
        const $root = document.documentElement;
        const $header = document.querySelector('.tenfit-header') || document.querySelector('header');

        const QS = (sel, ctx = document) => {
            try { return ctx.querySelector(sel); } catch { return null; }
        };

        const findAnn = () =>
            QS('[id^="m-announcement--"] .m-announcement-bar') ||
            QS('[id^="m-announcement--"]') ||
            QS('[data-section-type="announcement"]') ||
            QS('.m-announcement-bar');

        const px = n => `${Math.max(0, Math.round(Number(n) || 0))}px`;

        const shown = el => {
            if (!el) return false;
            const rect = el.getBoundingClientRect();
            return rect.height > 0 && getComputedStyle(el).display !== 'none';
        };

        function recalc() {
            const $ann = findAnn();
            const varAnn = getComputedStyle($root).getPropertyValue('--m-announcement-height').trim();

            let annH = 0;
            if (varAnn && varAnn.includes('px')) {
                annH = parseInt(varAnn, 10) || 0;
            } else if (shown($ann)) {
                const host = $ann.closest('[id^="m-announcement--"]') || $ann;
                annH = host.getBoundingClientRect().height || 0;
            }

            const headH = shown($header) ? $header.getBoundingClientRect().height : 56;

            $root.style.setProperty('--ann-h', px(annH));
            $root.style.setProperty('--header-h', px(headH));
            $root.style.setProperty('--header-total-h', px(annH + headH));
        }

        const rafRecalc = () => requestAnimationFrame(recalc);

        window.addEventListener('resize', rafRecalc, { passive: true });
        window.addEventListener('load', recalc);
        document.addEventListener('DOMContentLoaded', recalc);

        // REVISIÓN DE LLAVES AQUÍ:
        if (window.ResizeObserver) {
            // En iPhone/Safari es mejor NO usar ResizeObserver para el header 
            // si causa parpadeos, pero el chequeo de sintaxis es este:
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            if (!isIOS) {
                const ro = new ResizeObserver(rafRecalc);
                if ($header) ro.observe($header);
            }
        } // Cierre de ResizeObserver

        if (window.MutationObserver) {
            const mo = new MutationObserver(rafRecalc);
            const $ann0 = findAnn();
            if ($ann0) mo.observe($ann0, { attributes: true, childList: true, subtree: true });
            document.addEventListener('shopify:section:load', rafRecalc);
            document.addEventListener('shopify:section:unload', rafRecalc);
        }

        document.addEventListener('click', (e) => {
            if (e.target.closest('[data-mobile-toggle]') || e.target.closest('.m-announcement-bar__close')) {
                setTimeout(recalc, 10);
                setTimeout(recalc, 300); // Safari necesita un poco más de tiempo para terminar la animación
            }
        });

        window.addEventListener('orientationchange', () => {
            setTimeout(recalc, 300);
        });


        recalc();
    })(); // Cierre de la IIFE principal

    (() => {
        const MQ = window.matchMedia('(max-width: 1280px)');
        if (!MQ.matches) return;

        const ensureInfinite = (row) => {
            if (!row || row.dataset.infiniteApplied === '1') return;
            row.dataset.infiniteApplied = '1';

            // guarda los nodos semilla
            const seed = Array.from(row.children);

            // duplica para asegurar arranque con ancho suficiente
            let total = row.scrollWidth;
            let safetyLimit = 0;
            while (total < row.clientWidth * 2 && seed.length && safetyLimit < 5) {
                seed.forEach(n => row.appendChild(n.cloneNode(true)));
                total = row.scrollWidth;
                safetyLimit++;
            }

            // al acercarse al final, clona otra tanda
            const TH = 120;
            row.addEventListener('scroll', () => {
                const maxL = row.scrollWidth - row.clientWidth;
                if (row.scrollLeft > maxL - TH) {
                    seed.forEach(n => row.appendChild(n.cloneNode(true)));
                }
            }, { passive: true });
        };

        // inicial
        document.querySelectorAll('.js-infinite-row[data-infinite="1"]').forEach(ensureInfinite);

        // cuando se abra el drawer móvil, rebind dentro del panel
        document.addEventListener('tenfit:mobileMenuOpened', (e) => {
            const root = e.detail?.panel || document;
            root.querySelectorAll('.js-infinite-row[data-infinite="1"]').forEach(ensureInfinite);
        });
    })();

    // ==================== Push panel en el menú móvil (ocupa área + botón Volver) ====================
    (() => {
        const FOCUSABLE = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

        const focusFirst = (root) => {
            if (!root) return;
            const el = root.querySelector(FOCUSABLE);
            (el || root).focus?.({ preventScroll: true });
        };

        const bindPushLists = (root = document) => {
            const lists = root.querySelectorAll('.tenfit-header [data-mobile-list]');
            lists.forEach((list) => {
                if (list.dataset.pushBound === '1') return;
                list.dataset.pushBound = '1';

                // === Push panel (nivel 1) ===
                list.addEventListener('click', (e) => {
                    const summary = e.target.closest('.accordion-item.pushable > summary');
                    if (!summary) return;

                    e.preventDefault(); // evita el toggle nativo del <details>

                    const details = summary.parentElement; // <details> .mobile-extra-links
                    const hasSubmenu = !!details.querySelector(
                        '.accordion-submenu, .mobile-extras, .mobile-giftcards'
                    );
                    if (!hasSubmenu) return;

                    // Cierra cualquiera ya abierto
                    list.querySelectorAll('.accordion-item.is-open').forEach(it => {
                        if (it !== details) {
                            it.open = false;
                            it.classList.remove('is-open');
                            it.querySelector('summary')?.setAttribute('aria-expanded', 'false');
                        }
                    });

                    // Abre/activa el actual
                    details.open = true;
                    details.classList.add('is-open');
                    summary.setAttribute('aria-expanded', 'true');
                    list.classList.add('is-pushed');

                    // Enfoca el "Volver" si existe
                    const backBtn = details.querySelector('[data-push-back]') || summary;
                    const focusable = backBtn.closest('.accordion-item')
                        ?.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    (focusable || backBtn).focus?.({ preventScroll: true });
                });

                // Teclado: Enter/Espacio sobre summary también empuja
                list.addEventListener('keydown', (e) => {
                    const summary = e.target.closest('.accordion-item.pushable > summary');
                    if (!summary) return;
                    if (e.key !== 'Enter' && e.key !== ' ') return;
                    e.preventDefault();
                    summary.click();
                });

                // Botón VOLVER
                list.addEventListener('click', (e) => {
                const back = e.target.closest('[data-push-back]');
                if (!back) return;

                e.preventDefault();
                e.stopPropagation();

                const openItem = list.querySelector('.accordion-item.is-open');
                if (openItem) {
                  // Limpieza total del estado visual y funcional
                  openItem.classList.remove('is-open');
                  openItem.open = false;
                  openItem.removeAttribute('open');
                  
                  // Resetear la flecha específica de este ítem
                  const icon = openItem.querySelector('summary .accordion-icon');
                  if (icon) icon.classList.remove('rotate');
                  
                  openItem.querySelector('summary')?.setAttribute('aria-expanded', 'false');
                  openItem.querySelector('summary')?.focus?.({ preventScroll: true });
                }

                list.classList.remove('is-pushed');
              });



                // Accesibilidad: Escape vuelve
                list.addEventListener('keydown', (e) => {
                    if (e.key !== 'Escape') return;
                    if (!list.classList.contains('is-pushed')) return;
                    e.preventDefault();

                    const openItem = list.querySelector('.accordion-item.is-open');
                    if (openItem) {
                        openItem.open = false;
                        openItem.removeAttribute('open'); // clave
                        openItem.classList.remove('is-open');
                        openItem.querySelector('summary')?.setAttribute('aria-expanded', 'false');
                        openItem.querySelector('summary')?.focus?.({ preventScroll: true });
                    }
                    list.classList.remove('is-pushed');
                });

                // === Acordeón de subcategorías (nivel 2) — SOLO dentro del drawer móvil ===
                list.addEventListener('click', (e) => {
                  if (!list.closest('.mobile-menu-panel')) return;

                  const sum = e.target.closest('.sub-accordion-summary');
                  if (!sum) return;

                  e.preventDefault(); 
                  e.stopPropagation();

                  const d = sum.parentElement;                       // <details class="sub-accordion-item">
                  const group = d.closest('.accordion-submenu');     // <ul> contenedor
                  
                  // Detectamos si está abierto mirando el atributo nativo (funciona en ambos)
                  const isOpen = d.hasAttribute('open');

                  // 1. Cierra hermanas abiertas (Comportamiento de acordeón único)
                  group?.querySelectorAll('.sub-accordion-item').forEach((other) => {
                    if (other !== d) {
                      other.open = false;
                      other.removeAttribute('open');
                      other.classList.remove('is-open'); // Clase para CSS
                      const s = other.querySelector('.sub-accordion-summary');
                      s?.setAttribute('aria-expanded', 'false');
                      s?.querySelector('.accordion-icon')?.classList.remove('rotate');
                    }
                  });

                  // 2. Toggle del elemento actual
                  if (!isOpen) {
                    // ABRIR
                    d.setAttribute('open', ''); 
                    d.open = true;
                    d.classList.add('is-open');
                    sum.setAttribute('aria-expanded', 'true');
                    sum.querySelector('.accordion-icon')?.classList.add('rotate');
                  } else {
                    // CERRAR
                    d.removeAttribute('open');
                    d.open = false;
                    d.classList.remove('is-open');
                    sum.setAttribute('aria-expanded', 'false');
                    sum.querySelector('.accordion-icon')?.classList.remove('rotate');
                  }
                });

                // Teclado en mobile (Enter/Espacio) para subcategorías
                list.addEventListener('keydown', (e) => {
                    if (!list.closest('.mobile-menu-panel')) return;
                    const sum = e.target.closest('.sub-accordion-summary');
                    if (!sum) return;
                    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sum.click(); }
                });
            });
        };

        // 1) Bind inicial por si ya está en el DOM
        bindPushLists(document);

        // 2) Re-bind cada vez que se abre el drawer (evento que emitimos en open())
        document.addEventListener('tenfit:mobileMenuOpened', (e) => {
            const { panel } = e.detail || {};
            if (panel) bindPushLists(panel);
        });

        // 3) Salvaguarda: si hubiese algún .is-open sin atributo open al abrir, corrígelo
        document.addEventListener('tenfit:mobileMenuOpened', (e) => {
            const { panel } = e.detail || {};
            (panel || document).querySelectorAll('[data-mobile-list] .accordion-item.is-open').forEach(it => {
                it.open = true;
                it.setAttribute('open', '');
            });
        });
    })();


    // ==================== Mega Desktop ====================
    const getMenuPanel = (item) => item.querySelector('.mega-menu, .mega-menu-essentials-wrapper, .mega-menu-accessories-wrapper, .mega-menu-sale-wrapper');
    const getMenuTrigger = (item) => item.querySelector(':scope > a');

    const closeAllMega = () => {
        $$('.menu-item.has-mega').forEach((item) => {
            item.classList.remove('show-mega');
            const trigger = getMenuTrigger(item);
            const panel = getMenuPanel(item);
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            if (panel) {
                hideEl(panel);
                panel.querySelectorAll('.category-sublist').forEach(s => { s.classList.remove('open'); s.hidden = true; });
                panel.querySelectorAll('.category-title.open').forEach(t => t.classList.remove('open'));
                panel.querySelectorAll('.toggle-icon.rotate').forEach(i => i.classList.remove('rotate'));
            }
        });
    };

    const openMega = (item) => {
        const panel = getMenuPanel(item);
        const trigger = getMenuTrigger(item);
        if (!panel || !trigger) return;
        const rect = item.getBoundingClientRect();
        panel.style.setProperty('--mega-menu-left-offset', `${rect.left}px`);
        const useFlex = panel.classList.contains('mega-menu') || panel.classList.contains('mega-menu-essentials-wrapper');
        showEl(panel, useFlex ? 'flex' : 'block');
        item.classList.add('show-mega');
        trigger.setAttribute('aria-expanded', 'true');
    };

    $$('.menu-item.has-mega').forEach((item) => {
        let hideTimer;
        const panel = getMenuPanel(item);
        if (!panel) return;

        const onEnter = () => { clearTimeout(hideTimer); closeAllMega(); openMega(item); };
        const onLeave = () => {
            hideTimer = setTimeout(() => {
                if (!item.matches(':hover') && !panel.matches(':hover')) {
                    item.classList.remove('show-mega');
                    hideEl(panel);
                    const trigger = getMenuTrigger(item);
                    if (trigger) trigger.setAttribute('aria-expanded', 'false');
                    panel.querySelectorAll('.category-sublist').forEach(s => { s.classList.remove('open'); s.hidden = true; });
                    panel.querySelectorAll('.category-title.open').forEach(t => t.classList.remove('open'));
                    panel.querySelectorAll('.toggle-icon.rotate').forEach(i => i.classList.remove('rotate'));
                }
            }, 180);
        };

        item.addEventListener('pointerenter', onEnter);
        item.addEventListener('pointerleave', onLeave);
        panel.addEventListener('pointerleave', onLeave);

        item.addEventListener('mouseenter', onEnter);
        item.addEventListener('mouseleave', onLeave);
        panel.addEventListener('mouseleave', onLeave);
    });

    // ==================== Toggle subcategorías (nivel 3) ====================
    // ===== Toggle subcategorías (nivel 3) — SOLO DESKTOP (ignora el drawer) =====
    (() => {
        const closeItem = (titleEl) => {
            if (!titleEl) return;
            titleEl.classList.remove('open');
            titleEl.setAttribute('aria-expanded', 'false');
            const sub = document.getElementById(titleEl.dataset.toggleId);
            if (sub) { sub.classList.remove('open'); sub.hidden = true; }
            titleEl.querySelector('.toggle-icon')?.classList.remove('rotate');
        };

        const openItem = (titleEl) => {
            titleEl.classList.add('open');
            titleEl.setAttribute('aria-expanded', 'true');
            const sub = document.getElementById(titleEl.dataset.toggleId);
            if (sub) { sub.classList.add('open'); sub.hidden = false; }
            titleEl.querySelector('.toggle-icon')?.classList.add('rotate');
        };

        document.addEventListener('click', (e) => {
            // ⛔ Si el click ocurre dentro del panel móvil, no hacemos nada
            if (e.target.closest('.mobile-menu-panel')) return;

            const t = e.target.closest('.category-title.has-toggle');
            if (!t) return;

            e.preventDefault();
            const scope = t.closest('.menu-column-left') || t.closest('.mega-menu');
            if (!scope) return;

            const willOpen = !t.classList.contains('open');

            scope.querySelectorAll('.category-title.has-toggle.open').forEach((other) => {
                if (other !== t) closeItem(other);
            });

            willOpen ? openItem(t) : closeItem(t);
        });

        document.addEventListener('keydown', (e) => {
            if (e.target.closest('.mobile-menu-panel')) return;
            const t = e.target.closest('.category-title.has-toggle');
            if (!t) return;
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
        });
    })();

    // ==================== Tabs Sale (desktop) ====================
    (() => {
        const MQ_DESKTOP = window.matchMedia('(min-width:1281px)');

        const bindTabsIn = (scope = document) => {
            scope.querySelectorAll('.mega-menu-sale:not([data-sale-bound="1"])').forEach((root) => {
                root.dataset.saleBound = '1';

                const tabs = root.querySelectorAll('.sale-tab-button[role="tab"]');
                const panels = root.querySelectorAll('.sale-tab-content[role="tabpanel"]');
                if (!tabs.length || !panels.length) return;

                const activate = (tab) => {
                    const targetId = tab.getAttribute('aria-controls');
                    // tabs
                    tabs.forEach(t => {
                        const isActive = t === tab;
                        t.classList.toggle('active', isActive);
                        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
                        t.setAttribute('tabindex', isActive ? '0' : '-1');
                    });
                    // panels (sin usar hidden => control por clase + aria-hidden)
                    panels.forEach(p => {
                        const isTarget = p.id === targetId;
                        p.classList.toggle('active', isTarget);
                        p.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
                        p.removeAttribute('hidden'); // por si vino con hidden de Liquid
                    });
                };

                // Click / Enter / Space
                tabs.forEach(tab => {
                    tab.addEventListener('click', (e) => { if (!MQ_DESKTOP.matches) return; e.preventDefault(); activate(tab); });
                    tab.addEventListener('keydown', (e) => {
                        if (!MQ_DESKTOP.matches) return;
                        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(tab); }
                    });
                });

                // Navegación con flechas (accesibilidad)
                const focusTab = (idx) => tabs[idx]?.focus();
                root.addEventListener('keydown', (e) => {
                    if (!MQ_DESKTOP.matches) return;
                    const current = document.activeElement;
                    if (!current || !current.matches('.sale-tab-button[role="tab"]')) return;
                    const i = Array.prototype.indexOf.call(tabs, current);
                    if (e.key === 'ArrowRight') { e.preventDefault(); focusTab(Math.min(i + 1, tabs.length - 1)); }
                    if (e.key === 'ArrowLeft') { e.preventDefault(); focusTab(Math.max(i - 1, 0)); }
                });

                // Estado inicial: respeta aria-selected o cae al primero
                const initial = root.querySelector('.sale-tab-button[aria-selected="true"]') || tabs[0];
                if (initial) activate(initial);
            });
        };

        // Bind inicial
        bindTabsIn(document);

        // Rebind si Shopify recarga la sección del header
        document.addEventListener('shopify:section:load', (e) => bindTabsIn(e.target || document));

        // Rebind cuando cambie el breakpoint
        MQ_DESKTOP.addEventListener?.('change', () => bindTabsIn(document));
    })();

    // ==================== “New”: mostrar productos por subcategoría ====================
    (() => {
        const isMobile = window.matchMedia('(max-width: 1280px)').matches;
        if (isMobile) return;

        const handleize = (s) => String(s || '')
            .toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/&/g, 'y')
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '')
            .replace(/-+/g, '-')
            .trim();

        const findMenuItemByTitle = (title) => {
            const items = document.querySelectorAll('.menu-item.has-mega');
            const target = title.toLowerCase();
            for (const it of items) {
                const dt = it.dataset.title?.toLowerCase();
                if (dt === target) return it;
                const a = it.querySelector(':scope > a');
                if (a && a.textContent.trim().toLowerCase() === target) return it;
            }
            return null;
        };

        const item = findMenuItemByTitle('New');
        if (!item) return;
        const mega = item.querySelector('.mega-menu');
        if (!mega) return;
        const blocks = mega.querySelectorAll('.subcategory-recommendation');
        if (!blocks.length) return;

        const showKey = (key) => { blocks.forEach(b => { b.style.display = (b.dataset.category === key) ? 'block' : 'none'; }); };
        const candidateSelector = '.menu-column-left .category-group .category-title, .menu-column-left .category-group a';
        const pickKeyFromEl = (el) => handleize((el.getAttribute('data-category') || el.textContent || '').split('-')[0]);

        const maybeShow = (targetEl, evt) => {
            if (!targetEl) return;
            const key = pickKeyFromEl(targetEl);
            if ([...blocks].some(b => b.dataset.category === key)) {
                if (evt?.type === 'click') evt.preventDefault();
                showKey(key);
            }
        };

        mega.addEventListener('pointerenter', (e) => { const t = e.target.closest(candidateSelector); if (t) maybeShow(t); });
        mega.addEventListener('mouseenter', (e) => { const t = e.target.closest(candidateSelector); if (t) maybeShow(t); }, true);
        mega.addEventListener('click', (e) => { const t = e.target.closest(candidateSelector); if (t) maybeShow(t, e); });
        mega.addEventListener('keydown', (e) => {
            const t = e.target.closest(candidateSelector); if (!t) return;
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); maybeShow(t, e); }
        });
    })();

    // ==================== Horizontal drag (si lo usas) ====================
    $$('.collection-list-horizontal, .collection-horizontal-scroll').forEach((slider) => {
        let active = false, startX = 0, scrollLeft = 0;
        slider.addEventListener('pointerdown', (e) => {
            active = true; slider.classList.add('dragging');
            startX = e.clientX; scrollLeft = slider.scrollLeft; slider.setPointerCapture?.(e.pointerId);
        });
        slider.addEventListener('pointermove', (e) => {
            if (!active) return; e.preventDefault(); slider.scrollLeft = scrollLeft - (e.clientX - startX) * 1.5;
        });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach(ev => slider.addEventListener(ev, (e) => {
            active = false; slider.classList.remove('dragging'); slider.releasePointerCapture?.(e.pointerId);
        }));
    });
});

// --- Keep one mega menu always open in desktop ---
// Cambia el texto a 'Sale', 'Accesorios', etc. (igual al link visible)

// (function keepMegaOpen(title = 'Hombre'){
//   const isDesktop = window.matchMedia('(min-width:1025px)');
//   const open = () => {
//     if (!isDesktop.matches) return;

//     const items = Array.from(document.querySelectorAll('.menu-item.has-mega'));
//     const item  = items.find(it => {
//       const t = (it.dataset.title || it.querySelector(':scope > a')?.textContent || '').trim().toLowerCase();
//       return t === title.toLowerCase();
//     });
//     if (!item) return;

//     const panel = item.querySelector('.mega-menu, .mega-menu-essentials-wrapper, .mega-menu-accessories-wrapper, .mega-menu-sale-wrapper');
//     if (!panel) return;

//     // 1) abrirlo
//     item.classList.add('show-mega');
//     panel.removeAttribute('hidden');
//     panel.style.display = (panel.classList.contains('mega-menu') || panel.classList.contains('mega-menu-essentials-wrapper')) ? 'flex' : 'block';
//     item.querySelector(':scope > a')?.setAttribute('aria-expanded','true');

//     // 2) impedir que se cierre por los listeners de mouseleave/pointerleave
//     ['mouseleave','pointerleave'].forEach(ev => {
//       item.addEventListener(ev, e => e.stopImmediatePropagation(), true);
//       panel.addEventListener(ev, e => e.stopImmediatePropagation(), true);
//     });
//   };

//   open();
//   isDesktop.addEventListener?.('change', open);
//   document.addEventListener('shopify:section:load', open);
// })();
// console.log({
//   ann: getComputedStyle(document.documentElement).getPropertyValue('--ann-h'),
//   header: getComputedStyle(document.documentElement).getPropertyValue('--header-h'),
// });
